export enum AmlResult {
    Approved = 'APPROVED',
    Rejected = 'REJECTED',
    Pending = 'PENDING',
    Unknown = 'UNKNOWN',
    Review = 'REVIEW',
}
